import { makeStyles } from '@material-ui/core/styles';
export const useFormSendMailStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  chip: {
    '& .MuiChip-root': {
      backgroundColor: `${theme.palette.primary.light} !important`
    }
  }
}));
